import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { getUserGroupByStudio, getUserGroupByTeam } from '../../api/aops.api'
import {
  getStandaloneAdminData,
  getStandaloneAdminDataByStudio,
} from '../../api/standalone.api'
import AopsHeader from '../../components/apos/AopsHeader'
import SectionHeader from '../../components/apos/SectionHeader'
import CaseTrackBoard from '../../components/apos/case/CaseTrackBoard'
import {
  scheduleBoardRefetchTrigger,
  standaloneScheduleViewUserId,
  trackerBoardRefetchTrigger,
} from '../../store/standaloneSchedule'
import { userAuthStatus } from '../../store/user'
import './StandaloneSchedulePage.scss'
import ScheduleBoardAdminSection from './components/ScheduleBoardAdminSection'
import StandAloneAdminDashBoard from './components/StandAloneAdminDashBoard'
import StandAloneAdminTrackerBoardList from './components/StandAloneAdminTrackerBoardList'
import StandaloneFastPopup from './components/StandaloneFastPopup'
import StandaloneRoutineItemPopup from './components/StandaloneRoutineItemPopup'
import StandaloneScheduledTaskPopup from './components/StandaloneScheduledTaskPopup'
import StandaloneWatchdogPopup from './components/StandaloneWatchdogPopup'

const StandaloneAdminSchedulePage = () => {
  const [userAuth] = useRecoilState(userAuthStatus)
  const [adminData, setAdminData] = useState(null)
  const [isWatchdogPopupOpen, setIsWatchdogPopupOpen] = useState(false)
  const [selectedWatchdogId, setSelectedWatchdogId] = useState(null)
  const [isWatchdogTaskPopupOpen, setIsWatchdogTaskPopupOpen] = useState(false)
  const [selectedTaskId, setSelectedTaskId] = useState(null)
  const [selectedTask, setSelectedTask] = useState(null)
  const [watchdogDetailRefetchTrigger, setWatchdogDetailRefetchTrigger] =
    useState(0)
  const [isScheduledPopupOpen, setIsScheduledPopupOpen] = useState(false)
  const [selectedScheduledId, setSelectedScheduledId] = useState(null)
  const [isRoutinePopupOpen, setIsRoutinePopupOpen] = useState(false)
  const [selectedRoutineId, setSelectedRoutineId] = useState(null)
  const [isFastPopupOpen, setIsFastPopupOpen] = useState(false)
  const [selectedFastId, setSelectedFastId] = useState(null)
  const setTrackerBoardRefetch = useSetRecoilState(trackerBoardRefetchTrigger)
  const setScheduleBoardRefetch = useSetRecoilState(scheduleBoardRefetchTrigger)
  const setViewUserId = useSetRecoilState(standaloneScheduleViewUserId)

  useEffect(() => {
    setViewUserId(null)
  }, [setViewUserId])

  const handleRefetchTrackerBoard = () => {
    setTrackerBoardRefetch((prev) => prev + 1)
    setScheduleBoardRefetch((prev) => prev + 1)
    // adminData도 다시 가져오기
    initData()
  }

  const handleTaskPopupSuccess = () => {
    handleRefetchTrackerBoard()
    setWatchdogDetailRefetchTrigger((prev) => prev + 1)
  }

  const { studio: urlStudio, team: urlTeam } = useParams()
  const effectiveTeam = urlTeam ?? userAuth.teamName
  const isStudioRoute = Boolean(urlStudio && !urlTeam)

  const initData = async () => {
    if (isStudioRoute) {
      if (!urlStudio) return
      try {
        const res = await getUserGroupByStudio({ studioName: urlStudio })
        const studioGroupId = res?.studioGroupId
        if (studioGroupId !== null) {
          fetchAdminData(studioGroupId, 'studio')
        }
      } catch (error) {
        console.error('initData studio::', error)
      }
      return
    }
    if (!effectiveTeam) return
    try {
      const res = await getUserGroupByTeam({ teamName: effectiveTeam })
      const teamGroupId = res?.data?.teamId ?? res?.teamId
      if (teamGroupId !== null) {
        fetchAdminData(teamGroupId, 'team')
      }
    } catch (error) {
      console.error('initData team::', error)
    }
  }

  const fetchAdminData = async (groupId, level) => {
    try {
      const res =
        level === 'studio'
          ? await getStandaloneAdminDataByStudio(groupId)
          : await getStandaloneAdminData(groupId)
      setAdminData(res)
      console.log('adminData::', res)
    } catch (error) {
      console.error('fetchAdminData::', error)
    }
  }

  useEffect(() => {
    initData()
  }, [urlStudio, urlTeam, effectiveTeam, isStudioRoute])

  return (
    <>
      <div className="standalone-schedule-page">
        <AopsHeader active="schedule-dashboard" />
        <div style={{ padding: '16px 32px' }}>
          <SectionHeader
            title="Ops. 보드"
            subtitle="팀에서 발생한 이슈를 한눈에 확인할 수 있어요"
            buttonText="Weekly Goal 생성"
            buttonColor1="#191A1C"
            icon1={
              <img
                src="/assets/icon/aops/black-circle-star-icon.svg"
                alt="watchdog"
                style={{ width: '20px', height: '20px', marginRight: '6px' }}
              />
            }
            onButtonClick={() => {
              setSelectedWatchdogId(null)
              setIsWatchdogPopupOpen(true)
            }}
          />

          <StandAloneAdminDashBoard
            onWatchdogClick={(watchdog) => {
              setSelectedWatchdogId(watchdog.id)
              setIsWatchdogPopupOpen(true)
            }}
          />
          <div style={{ marginBottom: '12px' }} />
          <StandAloneAdminTrackerBoardList
            adminData={adminData}
            onWorkClick={(work) => {
              const workId = work.id
              if (work.workType === 'SCHEDULED') {
                setSelectedScheduledId(workId)
                setIsScheduledPopupOpen(true)
              } else if (work.workType === 'ROUTINE') {
                setSelectedRoutineId(workId)
                setIsRoutinePopupOpen(true)
              } else if (work.workType === 'FAST') {
                setSelectedFastId(workId)
                setIsFastPopupOpen(true)
              }
            }}
          />
          <div style={{ marginBottom: '60px' }} />
        </div>
        {/* <StandAloneAdminCaseList
            caseIssueSummary={adminData?.caseIssueSummary}
          /> */}
        <CaseTrackBoard />
        {/* //black-circle-star-icon.svg */}

        <ScheduleBoardAdminSection
          title="Scheduled 보드"
          subtitle="오늘 해야 할 루틴 업무를 명확히 하고 하나씩 완료해 나가세요"
        />

        {/* 트래커 보드 */}
        <StandaloneWatchdogPopup
          open={isWatchdogPopupOpen}
          onClose={(opts) => {
            setIsWatchdogPopupOpen(false)
            setSelectedWatchdogId(null)
            // 삭제 시 refetch를 다음 틱으로 미뤄서, 팝업이 먼저 open=false로 반영된 뒤에
            // refetchTrigger가 올라가도록 함 (그렇지 않으면 팝업이 삭제된 ID로 fetchWatchdogDetail 호출 → 실패 메시지)
            if (opts?.deleted) setTimeout(() => handleRefetchTrackerBoard(), 0)
          }}
          watchdogId={selectedWatchdogId}
          onSuccess={handleRefetchTrackerBoard}
          watchdogDetailRefetchTrigger={watchdogDetailRefetchTrigger}
          onOpenTaskPopup={() => {
            setSelectedTaskId(null)
            setSelectedTask(null)
            setIsWatchdogTaskPopupOpen(true)
          }}
          onOpenTaskEditPopup={(task) => {
            setSelectedTaskId(task.id)
            setSelectedTask(task)
            setIsWatchdogTaskPopupOpen(true)
          }}
        />
        {/* <StandaloneWatchdogTaskPopup
          open={isWatchdogTaskPopupOpen}
          onClose={() => {
            setIsWatchdogTaskPopupOpen(false)
            setSelectedTaskId(null)
            setSelectedTask(null)
            // selectedWatchdogId는 유지 → 워치도그 팝업이 수정 모드로 유지되도록
          }}
          watchdogId={selectedWatchdogId}
          taskId={selectedTaskId}
          task={selectedTask}
          onSuccess={handleTaskPopupSuccess}
        /> */}

        {/* Scheduled 업무 상세 팝업 */}
        <StandaloneScheduledTaskPopup
          id={selectedScheduledId}
          open={isScheduledPopupOpen}
          onClose={() => {
            setIsScheduledPopupOpen(false)
            setSelectedScheduledId(null)
          }}
          onSuccess={handleRefetchTrackerBoard}
        />

        {/* Routine 업무 상세 팝업 */}
        <StandaloneRoutineItemPopup
          id={selectedRoutineId}
          open={isRoutinePopupOpen}
          onClose={() => {
            setIsRoutinePopupOpen(false)
            setSelectedRoutineId(null)
          }}
          onSuccess={handleRefetchTrackerBoard}
        />

        {/* Fast 업무 상세 팝업 */}
        <StandaloneFastPopup
          id={selectedFastId}
          open={isFastPopupOpen}
          onClose={() => {
            setIsFastPopupOpen(false)
            setSelectedFastId(null)
          }}
          onSuccess={handleRefetchTrackerBoard}
        />

        <div style={{ marginBottom: '10px' }} />
      </div>
    </>
  )
}

export default StandaloneAdminSchedulePage
